import store from 'store'

function initialState () {
  return {
    company: null,
    ambito: null,
    current: { isImpersonate: false }
  }
}

export default {
  namespaced: true,

  state: initialState,

  mutations: {
    reset (state) {
      const initial = initialState()
      Object.keys(initial).forEach(key => state[key] = initial[key])
    },

    setSession (state, session) {
      state.company = session.company
      state.ambito = session.ambito
      state.current = session.current
    },

    setCompany (state, company) {
      state.company = company
    },

    setCurrent (state, current) {
      state.current = current
    },

    setAmbito (state, ambito) {
      state.ambito = ambito
    }
  },

  actions: {
    reset ({ commit }) {
      commit('reset')
    },

    setSession ({ commit }, session) {
      commit('setSession', session)
    },

    setCompany ({ commit }, company) {
      commit('setCompany', company)
    },

    setCurrent ({ commit }, current) {
      commit('setCurrent', current)
    },

    setAmbito ({ commit }, ambito) {
      commit('setAmbito', ambito)
    }
  },

  getters: {
    isImpersonate (state) {
      return state.current != null && state.current.isImpersonate && store.getters['auth/isAdmin']
    },

    getCurrent (state) {
      return state.current
    },

    getSession (state) {
      return { company: state.company, ambito: state.ambito, current: state.current }
    },

    getCompany (state) {
      return state.company
    },

    getAmbito (state) {
      return state.ambito
    }
  }
}
